import { render } from "./ShipmentInformation_Import.vue?vue&type=template&id=33edcf52"
import script from "./ShipmentInformation_Import.vue?vue&type=script&lang=js"
export * from "./ShipmentInformation_Import.vue?vue&type=script&lang=js"

import "./ShipmentInformation_Import.vue?vue&type=style&index=0&id=33edcf52&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__